import Marionette from 'backbone.marionette';
import billDetailVersionItemview from './bill_detail_version_itemview';
export default Marionette.CollectionView.extend({
  childView: billDetailVersionItemview,
  tagName: "div",
  className: "version-list"
});